import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { CustomerImportComponent } from 'OpsCenter/merchants/importing/customers/customer-import.component';
import { ReservationsImportComponent } from 'OpsCenter/merchants/importing/reservations/reservations-import.component';
import ImportRouter from './import.router';

const importModule = angular
  .module('ec.opsCenter.import', [])
  .config(ImportRouter)
  .directive('appCustomerImport', downgradeComponent({ component: CustomerImportComponent }) as angular.IDirectiveFactory)
  .directive('appReservationsImport', downgradeComponent({ component: ReservationsImportComponent }) as angular.IDirectiveFactory).name;

export default importModule;



// WEBPACK FOOTER //
// ./src/app/merchants/importing/import.module.ajs.ts